<!-- Wrapper container to hold the FormGroup -->
<div
    id="submodule-campaigns"
    [formGroup]="campaignStatusFormGroups"
    class="campaigns-container">
    @for (campaign of campaignsList$ | async; track campaign.id) {
        @if (campaign.id && !isCampaignInFinalStepAndStatus(campaign)) {
            <mat-card
                class="card-container"
                [class.campaign-flip-animation]="campaignFlipAnimationStates.get(Number(campaign.id))"
                [class.campaign-remove-animation]="campaignRemoveAnimationStates.get(Number(campaign.id))">
                <mat-card-content [formGroupName]="campaign.id">
                    <div class="campaign-card cw-flex-row">
                        <!-- General Data -->
                        <div class="campaign-data-box">
                            <p class="campaign-name">{{ campaign.name }}</p>
                            <p class="campaign-date-and-step">
                                <!-- start_date -->
                                <span> 🕔 {{ formatStandardDate(safeDate(campaign.start_date)) }} - </span>
                                <!-- end_date -->
                                <span
                                    [ngClass]="{
                                        'red-warning-text': isDateWithinDays(safeDate(campaign.end_date), 7),
                                    }">
                                    {{ formatStandardDate(safeDate(campaign.end_date)) }}
                                </span>
                                <!-- Splitter -->
                                <span> | </span>
                                <!-- Step Label -->
                                <span> ✔ </span>
                                <span>
                                    {{
                                        getLatestCampaignStep(campaign)?.label ??
                                            'Fehler: Schritt nicht gefunden!'
                                    }}
                                </span>
                            </p>
                        </div>

                        <!-- Select Box container to change the status of a campaign -->
                        <div class="campaign-status-box">
                            <mat-form-field class="status-select-box">
                                <mat-select
                                    formControlName="status_key"
                                    class="status-select">
                                    @for (status of campaignStatusListentries; track status) {
                                        <mat-option
                                            class="select-option"
                                            [ngClass]="{
                                                'status-color-start':
                                                    status.list_data?.category === STATUS_CATEGORY_START,
                                                'status-color-ongoing':
                                                    status.list_data?.category === STATUS_CATEGORY_ONGOING,
                                                'status-color-final':
                                                    status.list_data?.category === STATUS_CATEGORY_FINAL,
                                            }"
                                            [value]="status.list_key">
                                            {{ status.list_value }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        }
    }
</div>
